import Vue from 'vue'
import Vuex from 'vuex'
import tab from './modules/tab'
import settings from './modules/settings'
import tagsView  from './modules/tagsView'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

//创建vuex实例
export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    tab,settings,tagsView
  },
  plugins: [createPersistedState({
    // 配置选项
    storage: window.localStorage, // 或者使用 sessionStorage
    paths: ['tab','settings','tagsView'] // 指定要持久化的模块
  })]
})